export const FETCH_CORTES_REQUEST = "FETCH_CORTES_REQUEST";
export const FETCH_CORTES_SUCCESS = "FETCH_CORTES_SUCCESS";
export const FETCH_CORTES_FAILURE = "FETCH_CORTES_FAILURE";
